import { render, staticRenderFns } from "./TagMetadataCommonComponent.vue?vue&type=template&id=50760d6c&scoped=true"
import script from "./TagMetadataCommonComponent.vue?vue&type=script&lang=js"
export * from "./TagMetadataCommonComponent.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./TagMetadataCommonComponent.vue?vue&type=style&index=1&id=50760d6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50760d6c",
  null
  
)

export default component.exports